"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("./utils");
var OrderSet = /** @class */ (function () {
    function OrderSet() {
        this._map = new Map();
        this[Symbol.iterator] = this.values;
    }
    OrderSet.prototype.size = function () {
        return this._map.size;
    };
    OrderSet.prototype.addAsync = function (item) {
        return __awaiter(this, void 0, void 0, function () {
            var orderHash;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, utils_1.utils.getOrderHashAsync(item)];
                    case 1:
                        orderHash = _a.sent();
                        item.metaData.orderHash = orderHash;
                        this._map.set(orderHash, item);
                        return [2 /*return*/];
                }
            });
        });
    };
    OrderSet.prototype.addManyAsync = function (items) {
        return __awaiter(this, void 0, void 0, function () {
            var e_1, _a, items_1, items_1_1, item, e_1_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 5, 6, 7]);
                        items_1 = __values(items), items_1_1 = items_1.next();
                        _b.label = 1;
                    case 1:
                        if (!!items_1_1.done) return [3 /*break*/, 4];
                        item = items_1_1.value;
                        return [4 /*yield*/, this.addAsync(item)];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3:
                        items_1_1 = items_1.next();
                        return [3 /*break*/, 1];
                    case 4: return [3 /*break*/, 7];
                    case 5:
                        e_1_1 = _b.sent();
                        e_1 = { error: e_1_1 };
                        return [3 /*break*/, 7];
                    case 6:
                        try {
                            if (items_1_1 && !items_1_1.done && (_a = items_1.return)) _a.call(items_1);
                        }
                        finally { if (e_1) throw e_1.error; }
                        return [7 /*endfinally*/];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    OrderSet.prototype.hasAsync = function (order) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _b = (_a = this._map).has;
                        return [4 /*yield*/, utils_1.utils.getOrderHashAsync(order)];
                    case 1: return [2 /*return*/, _b.apply(_a, [_c.sent()])];
                }
            });
        });
    };
    OrderSet.prototype.diffAsync = function (other) {
        return __awaiter(this, void 0, void 0, function () {
            var e_2, _a, e_3, _b, added, removed, _c, _d, otherItem, doesContainItem, _e, _f, e_2_1, _g, _h, item, doesContainItem, _j, _k, e_3_1;
            return __generator(this, function (_l) {
                switch (_l.label) {
                    case 0:
                        added = [];
                        removed = [];
                        _l.label = 1;
                    case 1:
                        _l.trys.push([1, 6, 7, 8]);
                        _c = __values(other.values()), _d = _c.next();
                        _l.label = 2;
                    case 2:
                        if (!!_d.done) return [3 /*break*/, 5];
                        otherItem = _d.value;
                        _f = (_e = this._map).has;
                        return [4 /*yield*/, utils_1.utils.getOrderHashAsync(otherItem)];
                    case 3:
                        doesContainItem = _f.apply(_e, [_l.sent()]);
                        if (!doesContainItem) {
                            added.push(otherItem);
                        }
                        _l.label = 4;
                    case 4:
                        _d = _c.next();
                        return [3 /*break*/, 2];
                    case 5: return [3 /*break*/, 8];
                    case 6:
                        e_2_1 = _l.sent();
                        e_2 = { error: e_2_1 };
                        return [3 /*break*/, 8];
                    case 7:
                        try {
                            if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                        }
                        finally { if (e_2) throw e_2.error; }
                        return [7 /*endfinally*/];
                    case 8:
                        _l.trys.push([8, 13, 14, 15]);
                        _g = __values(this.values()), _h = _g.next();
                        _l.label = 9;
                    case 9:
                        if (!!_h.done) return [3 /*break*/, 12];
                        item = _h.value;
                        _k = (_j = other._map).has;
                        return [4 /*yield*/, utils_1.utils.getOrderHashAsync(item)];
                    case 10:
                        doesContainItem = _k.apply(_j, [_l.sent()]);
                        if (!doesContainItem) {
                            removed.push(item);
                        }
                        _l.label = 11;
                    case 11:
                        _h = _g.next();
                        return [3 /*break*/, 9];
                    case 12: return [3 /*break*/, 15];
                    case 13:
                        e_3_1 = _l.sent();
                        e_3 = { error: e_3_1 };
                        return [3 /*break*/, 15];
                    case 14:
                        try {
                            if (_h && !_h.done && (_b = _g.return)) _b.call(_g);
                        }
                        finally { if (e_3) throw e_3.error; }
                        return [7 /*endfinally*/];
                    case 15: return [2 /*return*/, { added: added, removed: removed }];
                }
            });
        });
    };
    OrderSet.prototype.values = function () {
        return this._map.values();
    };
    OrderSet.prototype.deleteAsync = function (item) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _b = (_a = this._map).delete;
                        return [4 /*yield*/, utils_1.utils.getOrderHashAsync(item)];
                    case 1: return [2 /*return*/, _b.apply(_a, [_c.sent()])];
                }
            });
        });
    };
    OrderSet.prototype.deleteManyAsync = function (items) {
        return __awaiter(this, void 0, void 0, function () {
            var e_4, _a, items_2, items_2_1, item, e_4_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 5, 6, 7]);
                        items_2 = __values(items), items_2_1 = items_2.next();
                        _b.label = 1;
                    case 1:
                        if (!!items_2_1.done) return [3 /*break*/, 4];
                        item = items_2_1.value;
                        return [4 /*yield*/, this.deleteAsync(item)];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3:
                        items_2_1 = items_2.next();
                        return [3 /*break*/, 1];
                    case 4: return [3 /*break*/, 7];
                    case 5:
                        e_4_1 = _b.sent();
                        e_4 = { error: e_4_1 };
                        return [3 /*break*/, 7];
                    case 6:
                        try {
                            if (items_2_1 && !items_2_1.done && (_a = items_2.return)) _a.call(items_2);
                        }
                        finally { if (e_4) throw e_4.error; }
                        return [7 /*endfinally*/];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    return OrderSet;
}());
exports.OrderSet = OrderSet;
//# sourceMappingURL=order_set.js.map